import { ClassNameProps } from "@/types";

/**
 * Variants for the RottenTomatoes badge.
 */
enum RottenTomatoesBadgeVariant {
  AudienceScore = "audienceScore",
  CriticsScore = "criticsScore",
}

/**
 * Sizes for the RottenTomatoes component.
 * Only applies to TV platform.
 */
enum RottenTomatoesBadgeSize {
  Large = "large",
  Medium = "medium",
}

interface RottenTomatoesBadgeProps
  extends ClassNameProps,
    React.HTMLAttributes<HTMLDivElement> {
  variant: RottenTomatoesBadgeVariant;
  size?: RottenTomatoesBadgeSize;

  /* The numeric percentage to display */
  score: number;
}

export { RottenTomatoesBadgeVariant, RottenTomatoesBadgeSize };
export type { RottenTomatoesBadgeProps };
